import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectBlackFridayPromoDatesText } from 'shared/selectors/newbuildingBlackFriday';
import { IPromoInfo } from 'shared/types/newbuildingPromos';

interface IPromoSubtitleProps {
  promo: IPromoInfo;
}

export const PromoSubtitle: React.FC<IPromoSubtitleProps> = ({ promo }) => {
  const { isBlackFriday, subtitle } = promo;

  const promoDatesText = useSelector(selectBlackFridayPromoDatesText);

  if (isBlackFriday) {
    return <UIText2>{promoDatesText}</UIText2>;
  }

  if (subtitle) {
    return <UIText2 color="gray60_100">{promo.subtitle}</UIText2>;
  }

  return null;
};
